export enum QuestionCategoryType {
    None = 0,
    NoneDescription = 'None',
    ForPerformanceManager = 1,
    ForPerformanceManagerDescription = 'Subordinates',
    ForGradeBelowRespondent = 2,
    ForGradeBelowRespondentDescription = 'Junior grade',
    ForGradeEqualRespondent = 4,
    ForGradeEqualRespondentDescription = 'Same grade',
    ForGradeAboveRespondent = 8,
    ForGradeAboveRespondentDescription = 'Senior grade',
    ForOtherRespondents = 16,
    ForOtherRespondentsDescription = 'Other',
    ForProjectTeam = 32,
    ForProjectTeamDescription = 'Project team'
}
